export enum Locales {
  LATIN_AMERICAN_SPANISH = 'es_419',
  SIMPLIFIED_CHINESE = 'zh#Hans',
  AFAR = 'aa',
  AFAR_DJIBOUTI = 'aa_DJ',
  AFAR_ETHIOPIA = 'aa_ET',
  ABKHAZIAN = 'ab',
  ABKHAZIAN_GEORGIA = 'ab_GE',
  ACHINESE = 'ace',
  ACHINESE_INDONESIA = 'ace_ID',
  ACOLI = 'ach',
  ACOLI_UGANDA = 'ach_UG',
  ADANGME = 'ada',
  ADYGHE = 'ady',
  ADYGHE_RUSSIA = 'ady_RU',
  AVESTAN = 'ae',
  TUNISIAN_ARABIC = 'aeb',
  TUNISIAN_ARABIC_TUNISIA = 'aeb_TN',
  AFRIKAANS = 'af',
  AFRIKAANS_NAMIBIA = 'af_NA',
  AFRIKAANS_SOUTH_AFRICA = 'af_ZA',
  AGHEM = 'agq',
  AINU = 'ain',
  AINU_LATIN = 'ain#Latn',
  AKAN = 'ak',
  AKAN_GHANA = 'ak_GH',
  AKKADIAN = 'akk',
  ALABAMA = 'akz',
  ALEUT = 'ale',
  GHEG_ALBANIAN = 'aln',
  GHEG_ALBANIAN_KOSOVO = 'aln_XK',
  SOUTHERN_ALTAI = 'alt',
  AMHARIC = 'am',
  AMHARIC_ETHIOPIA = 'am_ET',
  ARAGONESE = 'an',
  OLD_ENGLISH = 'ang',
  ANGIKA = 'anp',
  ARABIC = 'ar',
  ARABIC_UNITED_ARAB_EMIRATES = 'ar_AE',
  ARABIC_BAHRAIN = 'ar_BH',
  ARABIC_DJIBOUTI = 'ar_DJ',
  ARABIC_ALGERIA = 'ar_DZ',
  ARABIC_EGYPT = 'ar_EG',
  ARABIC_WESTERN_SAHARA = 'ar_EH',
  ARABIC_ERITREA = 'ar_ER',
  ARABIC_ISRAEL = 'ar_IL',
  ARABIC_IRAQ = 'ar_IQ',
  ARABIC_JORDAN = 'ar_JO',
  ARABIC_COMOROS = 'ar_KM',
  ARABIC_KUWAIT = 'ar_KW',
  ARABIC_LEBANON = 'ar_LB',
  ARABIC_LIBYA = 'ar_LY',
  ARABIC_MOROCCO = 'ar_MA',
  ARABIC_MAURITANIA = 'ar_MR',
  ARABIC_OMAN = 'ar_OM',
  ARABIC_PALESTINIAN_TERRITORIES = 'ar_PS',
  ARABIC_QATAR = 'ar_QA',
  ARABIC_SAUDI_ARABIA = 'ar_SA',
  ARABIC_SUDAN = 'ar_SD',
  ARABIC_SOMALIA = 'ar_SO',
  ARABIC_SYRIA = 'ar_SY',
  CZECH = 'cs',
  CZECH_CZECHIA = 'cs_CZ',
  ARABIC_CHAD = 'ar_TD',
  ARABIC_TUNISIA = 'ar_TN',
  ARABIC_YEMEN = 'ar_YE',
  ARABIC_IRAN = 'ar_IR',
  ARABIC_SOUTH_SUDAN = 'ar_SS',
  ARABIC_UNITED_ARAB_EMIRATES_SYRIAC = 'ar_AE#Syrc',
  ARABIC_BAHRAIN_SYRIAC = 'ar_BH#Syrc',
  ARABIC_DJIBOUTI_SYRIAC = 'ar_DJ#Syrc',
  ARABIC_ALGERIA_SYRIAC = 'ar_DZ#Syrc',
  ARABIC_EGYPT_SYRIAC = 'ar_EG#Syrc',
  ARABIC_WESTERN_SAHARA_SYRIAC = 'ar_EH#Syrc',
  ARABIC_ERITREA_SYRIAC = 'ar_ER#Syrc',
  ARABIC_ISRAEL_SYRIAC = 'ar_IL#Syrc',
  ARABIC_IRAQ_SYRIAC = 'ar_IQ#Syrc',
  ARABIC_JORDAN_SYRIAC = 'ar_JO#Syrc',
  ARABIC_COMOROS_SYRIAC = 'ar_KM#Syrc',
  ARABIC_KUWAIT_SYRIAC = 'ar_KW#Syrc',
  ARABIC_LEBANON_SYRIAC = 'ar_LB#Syrc',
  ARABIC_LIBYA_SYRIAC = 'ar_LY#Syrc',
  ARABIC_MOROCCO_SYRIAC = 'ar_MA#Syrc',
  ARABIC_MAURITANIA_SYRIAC = 'ar_MR#Syrc',
  ARABIC_OMAN_SYRIAC = 'ar_OM#Syrc',
  ARABIC_PALESTINIAN_TERRITORIES_SYRIAC = 'ar_PS#Syrc',
  ENGLISH = 'en',
  ARABIC_QATAR_SYRIAC = 'ar_QA#Syrc',
  ARABIC_SAUDI_ARABIA_SYRIAC = 'ar_SA#Syrc',
  ARABIC_SUDAN_SYRIAC = 'ar_SD#Syrc',
  ARABIC_SOMALIA_SYRIAC = 'ar_SO#Syrc',
  ARABIC_SYRIA_SYRIAC = 'ar_SY#Syrc',
  ARABIC_CHAD_SYRIAC = 'ar_TD#Syrc',
  ARABIC_TUNISIA_SYRIAC = 'ar_TN#Syrc',
  ARABIC_YEMEN_SYRIAC = 'ar_YE#Syrc',
  ARABIC_IRAN_SYRIAC = 'ar_IR#Syrc',
  ARABIC_SOUTH_SUDAN_SYRIAC = 'ar_SS#Syrc',
  ARAMAIC = 'arc',
  MAPUCHE = 'arn',
  ARAONA = 'aro',
  ARAPAHO = 'arp',
  ALGERIAN_ARABIC = 'arq',
  ALGERIAN_ARABIC_ALGERIA = 'arq_DZ',
  NAJDI_ARABIC = 'ars',
  ARAWAK = 'arw',
  MOROCCAN_ARABIC = 'ary',
  MOROCCAN_ARABIC_MOROCCO = 'ary_MA',
  EGYPTIAN_ARABIC = 'arz',
  EGYPTIAN_ARABIC_EGYPT = 'arz_EG',
  ASSAMESE = 'as',
  ASSAMESE_INDIA = 'as_IN',
  ASU = 'asa',
  ASTURIAN = 'ast',
  ASTURIAN_SPAIN = 'ast_ES',
  AVARIC = 'av',
  AVARIC_RUSSIA = 'av_RU',
  KOTAVA = 'avk',
  AWADHI = 'awa',
  AWADHI_INDIA = 'awa_IN',
  AYMARA = 'ay',
  AYMARA_BOLIVIA = 'ay_BO',
  AZERBAIJANI_AZERBAIJAN_ARABIC = 'az_AZ#Arab',
  AZERBAIJANI_IRAQ = 'az_IQ',
  AZERBAIJANI_IRAN = 'az_IR',
  AZERBAIJANI_RUSSIA_ARABIC = 'az_RU#Arab',
  AZERBAIJANI_ARABIC = 'az#Arab',
  AZERBAIJANI_AZERBAIJAN_CYRILLIC = 'az_AZ#Cyrl',
  AZERBAIJANI_IRAQ_CYRILLIC = 'az_IQ#Cyrl',
  AZERBAIJANI_IRAN_CYRILLIC = 'az_IR#Cyrl',
  AZERBAIJANI_RUSSIA = 'az_RU',
  AZERBAIJANI_CYRILLIC = 'az#Cyrl',
  AZERBAIJANI_IRAQ_LATIN = 'az_IQ#Latn',
  AZERBAIJANI_IRAN_LATIN = 'az_IR#Latn',
  AZERBAIJANI_RUSSIA_LATIN = 'az_RU#Latn',
  AZERBAIJANI = 'az',
  BASHKIR = 'ba',
  BASHKIR_RUSSIA = 'ba_RU',
  BALUCHI = 'bal',
  BALUCHI_AFGHANISTAN = 'bal_AF',
  BALUCHI_IRAN = 'bal_IR',
  BALUCHI_PAKISTAN = 'bal_PK',
  BALUCHI_AFGHANISTAN_LATIN = 'bal_AF#Latn',
  BALUCHI_IRAN_LATIN = 'bal_IR#Latn',
  BALUCHI_PAKISTAN_LATIN = 'bal_PK#Latn',
  BALINESE = 'ban',
  BALINESE_INDONESIA = 'ban_ID',
  BAVARIAN = 'bar',
  BAVARIAN_AUSTRIA = 'bar_AT',
  BAVARIAN_GERMANY = 'bar_DE',
  BASAA = 'bas',
  BAMUN = 'bax',
  BATAK_TOBA = 'bbc',
  BATAK_TOBA_INDONESIA = 'bbc_ID',
  GHOMALA = 'bbj',
  BELARUSIAN = 'be',
  BELARUSIAN_BELARUS = 'be_BY',
  BEJA = 'bej',
  BEJA_SUDAN = 'bej_SD',
  BEMBA = 'bem',
  BEMBA_ZAMBIA = 'bem_ZM',
  BETAWI = 'bew',
  BETAWI_INDONESIA = 'bew_ID',
  BENA = 'bez',
  BAFUT = 'bfd',
  BADAGA = 'bfq',
  BULGARIAN = 'bg',
  BULGARIAN_BULGARIA = 'bg_BG',
  WESTERN_BALOCHI = 'bgn',
  WESTERN_BALOCHI_PAKISTAN = 'bgn_PK',
  BHOJPURI = 'bho',
  BHOJPURI_INDIA = 'bho_IN',
  BHOJPURI_MAURITIUS = 'bho_MU',
  BHOJPURI_NEPAL = 'bho_NP',
  BISLAMA = 'bi',
  BISLAMA_VANUATU = 'bi_VU',
  BIKOL = 'bik',
  BIKOL_PHILIPPINES = 'bik_PH',
  BINI = 'bin',
  BINI_NIGERIA = 'bin_NG',
  BANJAR = 'bjn',
  BANJAR_INDONESIA = 'bjn_ID',
  KOM = 'bkm',
  SIKSIKA = 'bla',
  BAMBARA_MALI = 'bm_ML',
  BAMBARA = 'bm',
  BAMBARA_MALI_N_KO = 'bm_ML#Nkoo',
  BAMBARA_N_KO = 'bm#Nkoo',
  BANGLA = 'bn',
  BANGLA_BANGLADESH = 'bn_BD',
  BANGLA_INDIA = 'bn_IN',
  TIBETAN = 'bo',
  TIBETAN_CHINA = 'bo_CN',
  BISHNUPRIYA = 'bpy',
  BAKHTIARI = 'bqi',
  BAKHTIARI_IRAN = 'bqi_IR',
  BRETON = 'br',
  BRAJ = 'bra',
  BRAHUI = 'brh',
  BRAHUI_PAKISTAN = 'brh_PK',
  BRAHUI_PAKISTAN_LATIN = 'brh_PK#Latn',
  BODO = 'brx',
  BODO_INDIA = 'brx_IN',
  BOSNIAN_BOSNIA_AND_HERZEGOVINA_CYRILLIC = 'bs_BA#Cyrl',
  BOSNIAN_CYRILLIC = 'bs#Cyrl',
  BOSNIAN = 'bs',
  AKOOSE = 'bss',
  BURIAT = 'bua',
  BUGINESE = 'bug',
  BUGINESE_INDONESIA = 'bug_ID',
  BULU = 'bum',
  BULU_CAMEROON = 'bum_CM',
  BLIN = 'byn',
  MEDUMBA = 'byv',
  CATALAN = 'ca',
  CATALAN_ANDORRA = 'ca_AD',
  CATALAN_SPAIN = 'ca_ES',
  CADDO = 'cad',
  CARIB = 'car',
  CAYUGA = 'cay',
  ATSAM = 'cch',
  CHAKMA_BANGLA = 'ccp#Beng',
  CHAKMA = 'ccp',
  CHECHEN = 'ce',
  CHECHEN_RUSSIA = 'ce_RU',
  CEBUANO = 'ceb',
  CEBUANO_PHILIPPINES = 'ceb_PH',
  CHIGA = 'cgg',
  CHIGA_UGANDA = 'cgg_UG',
  CHAMORRO = 'ch',
  CHAMORRO_GUAM = 'ch_GU',
  CHUUKESE = 'chk',
  CHUUKESE_MICRONESIA = 'chk_FM',
  MARI = 'chm',
  CHINOOK_JARGON = 'chn',
  CHOCTAW = 'cho',
  CHIPEWYAN = 'chp',
  CHIPEWYAN_UNIFIED_CANADIAN_ABORIGINAL_SYLLABICS = 'chp#Cans',
  CHEROKEE = 'chr',
  CHEYENNE = 'chy',
  CHICKASAW = 'cic',
  CENTRAL_KURDISH = 'ckb',
  CENTRAL_KURDISH_IRAQ = 'ckb_IQ',
  CENTRAL_KURDISH_IRAN = 'ckb_IR',
  CORSICAN = 'co',
  COPTIC_ARABIC = 'cop#Arab',
  COPTIC_GREEK = 'cop#Grek',
  CAPIZNON = 'cps',
  CREE = 'cr',
  CREE_LATIN = 'cr#Latn',
  CRIMEAN_TURKISH = 'crh',
  SESELWA_CREOLE_FRENCH = 'crs',
  SESELWA_CREOLE_FRENCH_SEYCHELLES = 'crs_SC',
  CZECH_SLOVAKIA = 'cs_SK',
  KASHUBIAN = 'csb',
  KASHUBIAN_POLAND = 'csb_PL',
  CHURCH_SLAVIC = 'cu',
  CHUVASH = 'cv',
  CHUVASH_RUSSIA = 'cv_RU',
  WELSH = 'cy',
  WELSH_UNITED_KINGDOM = 'cy_GB',
  DANISH = 'da',
  DANISH_DENMARK = 'da_DK',
  DANISH_GERMANY = 'da_DE',
  DAKOTA = 'dak',
  DARGWA = 'dar',
  TAITA = 'dav',
  GERMAN = 'de',
  AUSTRIAN_GERMAN = 'de_AT',
  GERMAN_BELGIUM = 'de_BE',
  SWISS_HIGH_GERMAN = 'de_CH',
  GERMAN_GERMANY = 'de_DE',
  GERMAN_LIECHTENSTEIN = 'de_LI',
  GERMAN_LUXEMBOURG = 'de_LU',
  GERMAN_BRAZIL = 'de_BR',
  GERMAN_CZECHIA = 'de_CZ',
  GERMAN_DENMARK = 'de_DK',
  GERMAN_FRANCE = 'de_FR',
  GERMAN_UNITED_KINGDOM = 'de_GB',
  GERMAN_HUNGARY = 'de_HU',
  GERMAN_KAZAKHSTAN = 'de_KZ',
  GERMAN_NETHERLANDS = 'de_NL',
  GERMAN_POLAND = 'de_PL',
  GERMAN_SLOVENIA = 'de_SI',
  GERMAN_SLOVAKIA = 'de_SK',
  GERMAN_UNITED_STATES = 'de_US',
  DELAWARE = 'del',
  SLAVE = 'den',
  SLAVE_UNIFIED_CANADIAN_ABORIGINAL_SYLLABICS = 'den#Cans',
  DOGRIB = 'dgr',
  DINKA = 'din',
  ZARMA = 'dje',
  ZARMA_NIGER = 'dje_NE',
  DOGRI = 'doi',
  DOGRI_INDIA = 'doi_IN',
  LOWER_SORBIAN = 'dsb',
  CENTRAL_DUSUN = 'dtp',
  DUALA = 'dua',
  MIDDLE_DUTCH = 'dum',
  DIVEHI = 'dv',
  DIVEHI_MALDIVES = 'dv_MV',
  JOLA_FONYI = 'dyo',
  JOLA_FONYI_SENEGAL = 'dyo_SN',
  JOLA_FONYI_SENEGAL_ARABIC = 'dyo_SN#Arab',
  DYULA = 'dyu',
  DYULA_BURKINA_FASO = 'dyu_BF',
  DZONGKHA = 'dz',
  DZONGKHA_BHUTAN = 'dz_BT',
  EMBU = 'ebu',
  EWE = 'ee',
  EWE_GHANA = 'ee_GH',
  EWE_TOGO = 'ee_TG',
  EFIK = 'efi',
  EFIK_NIGERIA = 'efi_NG',
  EMILIAN = 'egl',
  ANCIENT_EGYPTIAN = 'egy',
  EKAJUK = 'eka',
  GREEK = 'el',
  GREEK_CYPRUS = 'el_CY',
  GREEK_GREECE = 'el_GR',
  ENGLISH_ANTIGUA_AND_BARBUDA = 'en_AG',
  ENGLISH_ANGUILLA = 'en_AI',
  ENGLISH_AMERICAN_SAMOA = 'en_AS',
  AUSTRALIAN_ENGLISH = 'en_AU',
  ENGLISH_BARBADOS = 'en_BB',
  ENGLISH_BURUNDI = 'en_BI',
  ENGLISH_BERMUDA = 'en_BM',
  ENGLISH_BAHAMAS = 'en_BS',
  ENGLISH_BOTSWANA = 'en_BW',
  ENGLISH_BELIZE = 'en_BZ',
  CANADIAN_ENGLISH = 'en_CA',
  ENGLISH_COCOS_KEELING_ISLANDS = 'en_CC',
  ENGLISH_COOK_ISLANDS = 'en_CK',
  ENGLISH_CAMEROON = 'en_CM',
  ENGLISH_CHRISTMAS_ISLAND = 'en_CX',
  ENGLISH_DIEGO_GARCIA = 'en_DG',
  ENGLISH_DOMINICA = 'en_DM',
  ENGLISH_ERITREA = 'en_ER',
  ENGLISH_FIJI = 'en_FJ',
  ENGLISH_FALKLAND_ISLANDS = 'en_FK',
  ENGLISH_MICRONESIA = 'en_FM',
  BRITISH_ENGLISH = 'en_GB',
  ENGLISH_GRENADA = 'en_GD',
  ENGLISH_GUERNSEY = 'en_GG',
  ENGLISH_GHANA = 'en_GH',
  ENGLISH_GIBRALTAR = 'en_GI',
  ENGLISH_GAMBIA = 'en_GM',
  ENGLISH_GUAM = 'en_GU',
  ENGLISH_GUYANA = 'en_GY',
  ENGLISH_HONG_KONG_SAR_CHINA = 'en_HK',
  ENGLISH_IRELAND = 'en_IE',
  ENGLISH_ISLE_OF_MAN = 'en_IM',
  ENGLISH_INDIA = 'en_IN',
  ENGLISH_BRITISH_INDIAN_OCEAN_TERRITORY = 'en_IO',
  ENGLISH_JERSEY = 'en_JE',
  ENGLISH_JAMAICA = 'en_JM',
  ENGLISH_KENYA = 'en_KE',
  ENGLISH_KIRIBATI = 'en_KI',
  ENGLISH_ST_KITTS_AND_NEVIS = 'en_KN',
  ENGLISH_CAYMAN_ISLANDS = 'en_KY',
  ENGLISH_ST_LUCIA = 'en_LC',
  ENGLISH_LIBERIA = 'en_LR',
  ENGLISH_LESOTHO = 'en_LS',
  ENGLISH_MADAGASCAR = 'en_MG',
  ENGLISH_MARSHALL_ISLANDS = 'en_MH',
  ENGLISH_NORTHERN_MARIANA_ISLANDS = 'en_MP',
  ENGLISH_MONTSERRAT = 'en_MS',
  ENGLISH_MALTA = 'en_MT',
  ENGLISH_MAURITIUS = 'en_MU',
  ENGLISH_MALAWI = 'en_MW',
  ENGLISH_NAMIBIA = 'en_NA',
  ENGLISH_NORFOLK_ISLAND = 'en_NF',
  ENGLISH_NIGERIA = 'en_NG',
  ENGLISH_NAURU = 'en_NR',
  ENGLISH_NIUE = 'en_NU',
  ENGLISH_NEW_ZEALAND = 'en_NZ',
  ENGLISH_PAPUA_NEW_GUINEA = 'en_PG',
  ENGLISH_PHILIPPINES = 'en_PH',
  ENGLISH_PAKISTAN = 'en_PK',
  ENGLISH_PITCAIRN_ISLANDS = 'en_PN',
  ENGLISH_PUERTO_RICO = 'en_PR',
  ENGLISH_PALAU = 'en_PW',
  ENGLISH_RWANDA = 'en_RW',
  ENGLISH_SOLOMON_ISLANDS = 'en_SB',
  ENGLISH_SEYCHELLES = 'en_SC',
  ENGLISH_SUDAN = 'en_SD',
  ENGLISH_SINGAPORE = 'en_SG',
  ENGLISH_ST_HELENA = 'en_SH',
  ENGLISH_SIERRA_LEONE = 'en_SL',
  ENGLISH_SOUTH_SUDAN = 'en_SS',
  ENGLISH_SINT_MAARTEN = 'en_SX',
  ENGLISH_ESWATINI = 'en_SZ',
  ENGLISH_TURKS_AND_CAICOS_ISLANDS = 'en_TC',
  ENGLISH_TOKELAU = 'en_TK',
  ENGLISH_TONGA = 'en_TO',
  ENGLISH_TRINIDAD_AND_TOBAGO = 'en_TT',
  ENGLISH_TUVALU = 'en_TV',
  ENGLISH_TANZANIA = 'en_TZ',
  ENGLISH_UGANDA = 'en_UG',
  ENGLISH_US_OUTLYING_ISLANDS = 'en_UM',
  AMERICAN_ENGLISH = 'en_US',
  ENGLISH_ST_VINCENT_AND_GRENADINES = 'en_VC',
  ENGLISH_BRITISH_VIRGIN_ISLANDS = 'en_VG',
  ENGLISH_US_VIRGIN_ISLANDS = 'en_VI',
  ENGLISH_VANUATU = 'en_VU',
  ENGLISH_SAMOA = 'en_WS',
  ENGLISH_SOUTH_AFRICA = 'en_ZA',
  ENGLISH_ZAMBIA = 'en_ZM',
  ENGLISH_ZIMBABWE = 'en_ZW',
  ENGLISH_ASCENSION_ISLAND = 'en_AC',
  ENGLISH_UNITED_ARAB_EMIRATES = 'en_AE',
  ENGLISH_ARGENTINA = 'en_AR',
  ENGLISH_AUSTRIA = 'en_AT',
  ENGLISH_BOSNIA_AND_HERZEGOVINA = 'en_BA',
  ENGLISH_BANGLADESH = 'en_BD',
  ENGLISH_BELGIUM = 'en_BE',
  ENGLISH_BULGARIA = 'en_BG',
  ENGLISH_BRAZIL = 'en_BR',
  ENGLISH_SWITZERLAND = 'en_CH',
  ENGLISH_CHILE = 'en_CL',
  ENGLISH_CYPRUS = 'en_CY',
  ENGLISH_CZECHIA = 'en_CZ',
  ENGLISH_GERMANY = 'en_DE',
  ENGLISH_DENMARK = 'en_DK',
  ENGLISH_ALGERIA = 'en_DZ',
  ENGLISH_ESTONIA = 'en_EE',
  ENGLISH_EGYPT = 'en_EG',
  ENGLISH_SPAIN = 'en_ES',
  ENGLISH_ETHIOPIA = 'en_ET',
  ENGLISH_FINLAND = 'en_FI',
  ENGLISH_FRANCE = 'en_FR',
  ENGLISH_GREECE = 'en_GR',
  ENGLISH_CROATIA = 'en_HR',
  ENGLISH_HUNGARY = 'en_HU',
  ENGLISH_ISRAEL = 'en_IL',
  ENGLISH_IRAQ = 'en_IQ',
  ENGLISH_ITALY = 'en_IT',
  ENGLISH_JORDAN = 'en_JO',
  ENGLISH_KAZAKHSTAN = 'en_KZ',
  ENGLISH_LEBANON = 'en_LB',
  ENGLISH_SRI_LANKA = 'en_LK',
  ENGLISH_LITHUANIA = 'en_LT',
  ENGLISH_LUXEMBOURG = 'en_LU',
  ENGLISH_LATVIA = 'en_LV',
  ENGLISH_MOROCCO = 'en_MA',
  ENGLISH_MEXICO = 'en_MX',
  ENGLISH_MALAYSIA = 'en_MY',
  ENGLISH_NETHERLANDS = 'en_NL',
  ENGLISH_POLAND = 'en_PL',
  ENGLISH_PORTUGAL = 'en_PT',
  ENGLISH_ROMANIA = 'en_RO',
  ENGLISH_SWEDEN = 'en_SE',
  ENGLISH_SLOVENIA = 'en_SI',
  ENGLISH_SLOVAKIA = 'en_SK',
  ENGLISH_TRISTAN_DA_CUNHA = 'en_TA',
  ENGLISH_THAILAND = 'en_TH',
  ENGLISH_TURKEY = 'en_TR',
  ENGLISH_YEMEN = 'en_YE',
  MIDDLE_ENGLISH = 'enm',
  ESPERANTO = 'eo',
  SPANISH = 'es',
  SPANISH_ARGENTINA = 'es_AR',
  SPANISH_BOLIVIA = 'es_BO',
  SPANISH_CHILE = 'es_CL',
  SPANISH_COLOMBIA = 'es_CO',
  SPANISH_COSTA_RICA = 'es_CR',
  SPANISH_CUBA = 'es_CU',
  SPANISH_DOMINICAN_REPUBLIC = 'es_DO',
  SPANISH_CEUTA_AND_MELILLA = 'es_EA',
  SPANISH_ECUADOR = 'es_EC',
  EUROPEAN_SPANISH = 'es_ES',
  SPANISH_EQUATORIAL_GUINEA = 'es_GQ',
  SPANISH_GUATEMALA = 'es_GT',
  SPANISH_HONDURAS = 'es_HN',
  SPANISH_CANARY_ISLANDS = 'es_IC',
  MEXICAN_SPANISH = 'es_MX',
  SPANISH_NICARAGUA = 'es_NI',
  SPANISH_PANAMA = 'es_PA',
  SPANISH_PERU = 'es_PE',
  SPANISH_PUERTO_RICO = 'es_PR',
  SPANISH_PARAGUAY = 'es_PY',
  SPANISH_EL_SALVADOR = 'es_SV',
  SPANISH_URUGUAY = 'es_UY',
  SPANISH_VENEZUELA = 'es_VE',
  SPANISH_ANDORRA = 'es_AD',
  SPANISH_BELIZE = 'es_BZ',
  SPANISH_GERMANY = 'es_DE',
  SPANISH_FRANCE = 'es_FR',
  SPANISH_GIBRALTAR = 'es_GI',
  SPANISH_PHILIPPINES = 'es_PH',
  SPANISH_PORTUGAL = 'es_PT',
  SPANISH_ROMANIA = 'es_RO',
  SPANISH_UNITED_STATES = 'es_US',
  CENTRAL_YUPIK = 'esu',
  ESTONIAN = 'et',
  ESTONIAN_ESTONIA = 'et_EE',
  BASQUE = 'eu',
  BASQUE_SPAIN = 'eu_ES',
  EWONDO = 'ewo',
  EXTREMADURAN = 'ext',
  PERSIAN = 'fa',
  DARI = 'fa_AF',
  PERSIAN_IRAN = 'fa_IR',
  PERSIAN_PAKISTAN = 'fa_PK',
  FANG = 'fan',
  FANG_EQUATORIAL_GUINEA = 'fan_GQ',
  FULAH = 'ff',
  FULAH_GUINEA = 'ff_GN',
  FULAH_SENEGAL = 'ff_SN',
  FINNISH = 'fi',
  FINNISH_FINLAND = 'fi_FI',
  FINNISH_ESTONIA = 'fi_EE',
  FINNISH_SWEDEN = 'fi_SE',
  FILIPINO = 'fil',
  FILIPINO_PHILIPPINES = 'fil_PH',
  FILIPINO_UNITED_STATES = 'fil_US',
  TORNEDALEN_FINNISH = 'fit',
  FIJIAN = 'fj',
  FIJIAN_FIJI = 'fj_FJ',
  FAROESE = 'fo',
  FAROESE_FAROE_ISLANDS = 'fo_FO',
  FON = 'fon',
  FON_BENIN = 'fon_BJ',
  FRENCH = 'fr',
  FRENCH_BELGIUM = 'fr_BE',
  FRENCH_BURKINA_FASO = 'fr_BF',
  FRENCH_BURUNDI = 'fr_BI',
  FRENCH_BENIN = 'fr_BJ',
  FRENCH_ST_BARTHÉLEMY = 'fr_BL',
  CANADIAN_FRENCH = 'fr_CA',
  FRENCH_CONGO___KINSHASA = 'fr_CD',
  FRENCH_CENTRAL_AFRICAN_REPUBLIC = 'fr_CF',
  FRENCH_CONGO___BRAZZAVILLE = 'fr_CG',
  SWISS_FRENCH = 'fr_CH',
  FRENCH_CÔTE_D_IVOIRE = 'fr_CI',
  FRENCH_CAMEROON = 'fr_CM',
  FRENCH_DJIBOUTI = 'fr_DJ',
  FRENCH_ALGERIA = 'fr_DZ',
  FRENCH_FRANCE = 'fr_FR',
  FRENCH_GABON = 'fr_GA',
  FRENCH_FRENCH_GUIANA = 'fr_GF',
  FRENCH_GUINEA = 'fr_GN',
  FRENCH_GUADELOUPE = 'fr_GP',
  FRENCH_EQUATORIAL_GUINEA = 'fr_GQ',
  FRENCH_HAITI = 'fr_HT',
  FRENCH_COMOROS = 'fr_KM',
  FRENCH_LUXEMBOURG = 'fr_LU',
  FRENCH_MOROCCO = 'fr_MA',
  FRENCH_MONACO = 'fr_MC',
  FRENCH_ST_MARTIN = 'fr_MF',
  FRENCH_MADAGASCAR = 'fr_MG',
  FRENCH_MALI = 'fr_ML',
  FRENCH_MARTINIQUE = 'fr_MQ',
  FRENCH_MAURITIUS = 'fr_MU',
  FRENCH_NEW_CALEDONIA = 'fr_NC',
  FRENCH_NIGER = 'fr_NE',
  FRENCH_FRENCH_POLYNESIA = 'fr_PF',
  FRENCH_ST_PIERRE_AND_MIQUELON = 'fr_PM',
  FRENCH_RÉUNION = 'fr_RE',
  FRENCH_RWANDA = 'fr_RW',
  FRENCH_SEYCHELLES = 'fr_SC',
  FRENCH_SENEGAL = 'fr_SN',
  FRENCH_SYRIA = 'fr_SY',
  FRENCH_CHAD = 'fr_TD',
  FRENCH_TOGO = 'fr_TG',
  FRENCH_TUNISIA = 'fr_TN',
  FRENCH_VANUATU = 'fr_VU',
  FRENCH_WALLIS_AND_FUTUNA = 'fr_WF',
  FRENCH_MAYOTTE = 'fr_YT',
  FRENCH_GERMANY = 'fr_DE',
  FRENCH_UNITED_KINGDOM = 'fr_GB',
  FRENCH_ITALY = 'fr_IT',
  FRENCH_NETHERLANDS = 'fr_NL',
  FRENCH_PORTUGAL = 'fr_PT',
  FRENCH_ROMANIA = 'fr_RO',
  FRENCH_FRENCH_SOUTHERN_TERRITORIES = 'fr_TF',
  FRENCH_UNITED_STATES = 'fr_US',
  CAJUN_FRENCH = 'frc',
  MIDDLE_FRENCH = 'frm',
  OLD_FRENCH = 'fro',
  ARPITAN = 'frp',
  NORTHERN_FRISIAN = 'frr',
  EASTERN_FRISIAN = 'frs',
  FRIULIAN = 'fur',
  WESTERN_FRISIAN = 'fy',
  WESTERN_FRISIAN_NETHERLANDS = 'fy_NL',
  IRISH = 'ga',
  IRISH_IRELAND = 'ga_IE',
  IRISH_UNITED_KINGDOM = 'ga_GB',
  GA = 'gaa',
  GA_GHANA = 'gaa_GH',
  GAGAUZ = 'gag',
  GAGAUZ_CYRILLIC = 'gag#Cyrl',
  GAN_CHINESE = 'gan',
  GAN_CHINESE_CHINA = 'gan_CN',
  GAYO = 'gay',
  GBAYA = 'gba',
  ZOROASTRIAN_DARI = 'gbz',
  SCOTTISH_GAELIC = 'gd',
  SCOTTISH_GAELIC_UNITED_KINGDOM = 'gd_GB',
  GEEZ = 'gez',
  GILBERTESE = 'gil',
  GILBERTESE_KIRIBATI = 'gil_KI',
  GALICIAN = 'gl',
  GALICIAN_SPAIN = 'gl_ES',
  GILAKI = 'glk',
  GILAKI_IRAN = 'glk_IR',
  MIDDLE_HIGH_GERMAN = 'gmh',
  GUARANI = 'gn',
  GUARANI_PARAGUAY = 'gn_PY',
  OLD_HIGH_GERMAN = 'goh',
  GOAN_KONKANI = 'gom',
  GOAN_KONKANI_INDIA = 'gom_IN',
  GONDI_INDIA_DEVANAGARI = 'gon_IN#Deva',
  GONDI_DEVANAGARI = 'gon#Deva',
  GONDI_INDIA = 'gon_IN',
  GONDI = 'gon',
  GORONTALO = 'gor',
  GORONTALO_INDONESIA = 'gor_ID',
  GOTHIC = 'got',
  GREBO = 'grb',
  ANCIENT_GREEK = 'grc',
  SWISS_GERMAN = 'gsw',
  SWISS_GERMAN_SWITZERLAND = 'gsw_CH',
  SWISS_GERMAN_LIECHTENSTEIN = 'gsw_LI',
  SWISS_GERMAN_GERMANY = 'gsw_DE',
  GUJARATI = 'gu',
  GUJARATI_INDIA = 'gu_IN',
  WAYUU = 'guc',
  FRAFRA = 'gur',
  GUSII = 'guz',
  GUSII_KENYA = 'guz_KE',
  MANX = 'gv',
  MANX_ISLE_OF_MAN = 'gv_IM',
  GWICHʼIN = 'gwi',
  HAUSA_NIGER_ARABIC = 'ha_NE#Arab',
  HAUSA_NIGERIA_ARABIC = 'ha_NG#Arab',
  HAUSA_ARABIC = 'ha#Arab',
  HAUSA_NIGER = 'ha_NE',
  HAUSA_NIGERIA = 'ha_NG',
  HAUSA = 'ha',
  HAIDA = 'hai',
  HAKKA_CHINESE = 'hak',
  HAKKA_CHINESE_CHINA = 'hak_CN',
  HAWAIIAN = 'haw',
  HAWAIIAN_UNITED_STATES = 'haw_US',
  HEBREW = 'he',
  HEBREW_ISRAEL = 'he_IL',
  HINDI = 'hi',
  HINDI_INDIA = 'hi_IN',
  HINDI_FIJI = 'hi_FJ',
  HINDI_SOUTH_AFRICA = 'hi_ZA',
  FIJI_HINDI_FIJI_DEVANAGARI = 'hif_FJ#Deva',
  FIJI_HINDI_DEVANAGARI = 'hif#Deva',
  FIJI_HINDI_FIJI = 'hif_FJ',
  FIJI_HINDI = 'hif',
  HILIGAYNON = 'hil',
  HILIGAYNON_PHILIPPINES = 'hil_PH',
  HITTITE = 'hit',
  HMONG = 'hmn',
  HIRI_MOTU = 'ho',
  HIRI_MOTU_PAPUA_NEW_GUINEA = 'ho_PG',
  CROATIAN = 'hr',
  CROATIAN_BOSNIA_AND_HERZEGOVINA = 'hr_BA',
  CROATIAN_CROATIA = 'hr_HR',
  CROATIAN_AUSTRIA = 'hr_AT',
  CROATIAN_SERBIA = 'hr_RS',
  CROATIAN_SLOVENIA = 'hr_SI',
  UPPER_SORBIAN = 'hsb',
  XIANG_CHINESE = 'hsn',
  XIANG_CHINESE_CHINA = 'hsn_CN',
  HAITIAN_CREOLE = 'ht',
  HAITIAN_CREOLE_HAITI = 'ht_HT',
  HUNGARIAN = 'hu',
  HUNGARIAN_HUNGARY = 'hu_HU',
  HUNGARIAN_AUSTRIA = 'hu_AT',
  HUNGARIAN_ROMANIA = 'hu_RO',
  HUNGARIAN_SERBIA = 'hu_RS',
  HUPA = 'hup',
  ARMENIAN = 'hy',
  ARMENIAN_ARMENIA = 'hy_AM',
  ARMENIAN_RUSSIA = 'hy_RU',
  HERERO = 'hz',
  INTERLINGUA = 'ia',
  IBAN = 'iba',
  IBIBIO = 'ibb',
  IBIBIO_NIGERIA = 'ibb_NG',
  INDONESIAN = 'id',
  INDONESIAN_INDONESIA = 'id_ID',
  INDONESIAN_INDONESIA_ARABIC = 'id_ID#Arab',
  IGBO = 'ig',
  IGBO_NIGERIA = 'ig_NG',
  SICHUAN_YI = 'ii',
  SICHUAN_YI_CHINA = 'ii_CN',
  SICHUAN_YI_CHINA_LATIN = 'ii_CN#Latn',
  INUPIAQ = 'ik',
  ILOKO = 'ilo',
  ILOKO_PHILIPPINES = 'ilo_PH',
  INGUSH = 'inh',
  INGUSH_RUSSIA = 'inh_RU',
  INGUSH_RUSSIA_ARABIC = 'inh_RU#Arab',
  INGUSH_RUSSIA_LATIN = 'inh_RU#Latn',
  ICELANDIC = 'is',
  ICELANDIC_ICELAND = 'is_IS',
  ITALIAN = 'it',
  ITALIAN_SWITZERLAND = 'it_CH',
  ITALIAN_ITALY = 'it_IT',
  ITALIAN_SAN_MARINO = 'it_SM',
  ITALIAN_VATICAN_CITY = 'it_VA',
  ITALIAN_GERMANY = 'it_DE',
  ITALIAN_FRANCE = 'it_FR',
  ITALIAN_CROATIA = 'it_HR',
  ITALIAN_MALTA = 'it_MT',
  ITALIAN_UNITED_STATES = 'it_US',
  INUKTITUT_CANADA = 'iu_CA',
  INUKTITUT = 'iu',
  INUKTITUT_CANADA_LATIN = 'iu_CA#Latn',
  INUKTITUT_LATIN = 'iu#Latn',
  INGRIAN = 'izh',
  JAPANESE = 'ja',
  JAPANESE_JAPAN = 'ja_JP',
  JAMAICAN_CREOLE_ENGLISH = 'jam',
  JAMAICAN_CREOLE_ENGLISH_JAMAICA = 'jam_JM',
  NGOMBA = 'jgo',
  MACHAME = 'jmc',
  JUDEO_PERSIAN = 'jpr',
  JUDEO_ARABIC = 'jrb',
  JUTISH = 'jut',
  JAVANESE = 'jv',
  JAVANESE_INDONESIA = 'jv_ID',
  JAVANESE_INDONESIA_JAVANESE = 'jv_ID#Java',
  GEORGIAN = 'ka',
  GEORGIAN_GEORGIA = 'ka_GE',
  KARA_KALPAK = 'kaa',
  KABYLE = 'kab',
  KABYLE_ALGERIA = 'kab_DZ',
  KACHIN = 'kac',
  JJU = 'kaj',
  KAMBA = 'kam',
  KAMBA_KENYA = 'kam_KE',
  KABARDIAN = 'kbd',
  KABARDIAN_RUSSIA = 'kbd_RU',
  TYAP = 'kcg',
  MAKONDE = 'kde',
  MAKONDE_TANZANIA = 'kde_TZ',
  KABUVERDIANU = 'kea',
  KABUVERDIANU_CAPE_VERDE = 'kea_CV',
  KORO = 'kfo',
  KONGO = 'kg',
  KONGO_CONGO___KINSHASA = 'kg_CD',
  KAINGANG = 'kgp',
  KHASI = 'kha',
  KHASI_INDIA = 'kha_IN',
  KHASI_INDIA_BANGLA = 'kha_IN#Beng',
  KOYRA_CHIINI = 'khq',
  KHOWAR = 'khw',
  KIKUYU = 'ki',
  KIKUYU_KENYA = 'ki_KE',
  KIRMANJKI = 'kiu',
  KUANYAMA = 'kj',
  KUANYAMA_NAMIBIA = 'kj_NA',
  KAZAKH_KAZAKHSTAN_ARABIC = 'kk_KZ#Arab',
  KAZAKH_CHINA = 'kk_CN',
  KAZAKH_ARABIC = 'kk#Arab',
  KAZAKH_KAZAKHSTAN = 'kk_KZ',
  KAZAKH_CHINA_CYRILLIC = 'kk_CN#Cyrl',
  KAZAKH = 'kk',
  KAKO = 'kkj',
  KALAALLISUT = 'kl',
  KALAALLISUT_GREENLAND = 'kl_GL',
  KALAALLISUT_DENMARK = 'kl_DK',
  KALENJIN = 'kln',
  KALENJIN_KENYA = 'kln_KE',
  KHMER = 'km',
  KHMER_CAMBODIA = 'km_KH',
  KIMBUNDU = 'kmb',
  KIMBUNDU_ANGOLA = 'kmb_AO',
  KANNADA = 'kn',
  KANNADA_INDIA = 'kn_IN',
  KOREAN = 'ko',
  KOREAN_NORTH_KOREA = 'ko_KP',
  KOREAN_SOUTH_KOREA = 'ko_KR',
  KOREAN_CHINA = 'ko_CN',
  KOREAN_UNITED_STATES = 'ko_US',
  KOMI_PERMYAK = 'koi',
  KOMI_PERMYAK_RUSSIA = 'koi_RU',
  KONKANI = 'kok',
  KONKANI_INDIA = 'kok_IN',
  KOSRAEAN = 'kos',
  KPELLE = 'kpe',
  KANURI = 'kr',
  KARACHAY_BALKAR = 'krc',
  KARACHAY_BALKAR_RUSSIA = 'krc_RU',
  KRIO = 'kri',
  KRIO_SIERRA_LEONE = 'kri_SL',
  KINARAY_A = 'krj',
  KARELIAN = 'krl',
  KURUKH = 'kru',
  KURUKH_INDIA = 'kru_IN',
  KASHMIRI_INDIA = 'ks_IN',
  KASHMIRI = 'ks',
  KASHMIRI_INDIA_DEVANAGARI = 'ks_IN#Deva',
  KASHMIRI_DEVANAGARI = 'ks#Deva',
  SHAMBALA = 'ksb',
  BAFIA = 'ksf',
  COLOGNIAN = 'ksh',
  KURDISH_SYRIA = 'ku_SY',
  KURDISH_TURKEY_ARABIC = 'ku_TR#Arab',
  KURDISH_ARABIC = 'ku#Arab',
  KURDISH_SYRIA_CYRILLIC = 'ku_SY#Cyrl',
  KURDISH_TURKEY_CYRILLIC = 'ku_TR#Cyrl',
  KURDISH_CYRILLIC = 'ku#Cyrl',
  KURDISH_SYRIA_LATIN = 'ku_SY#Latn',
  KURDISH_TURKEY = 'ku_TR',
  KURDISH = 'ku',
  KUMYK = 'kum',
  KUMYK_RUSSIA = 'kum_RU',
  KUTENAI = 'kut',
  KOMI = 'kv',
  KOMI_RUSSIA = 'kv_RU',
  CORNISH = 'kw',
  KYRGYZ_KYRGYZSTAN_ARABIC = 'ky_KG#Arab',
  KYRGYZ_ARABIC = 'ky#Arab',
  KYRGYZ_KYRGYZSTAN = 'ky_KG',
  KYRGYZ = 'ky',
  KYRGYZ_KYRGYZSTAN_LATIN = 'ky_KG#Latn',
  KYRGYZ_LATIN = 'ky#Latn',
  LATIN = 'la',
  LATIN_VATICAN_CITY = 'la_VA',
  LADINO = 'lad',
  LANGI = 'lag',
  LAHNDA = 'lah',
  LAHNDA_PAKISTAN = 'lah_PK',
  LAMBA = 'lam',
  LUXEMBOURGISH = 'lb',
  LUXEMBOURGISH_LUXEMBOURG = 'lb_LU',
  LEZGHIAN = 'lez',
  LEZGHIAN_RUSSIA = 'lez_RU',
  LINGUA_FRANCA_NOVA_CYRILLIC = 'lfn#Cyrl',
  LINGUA_FRANCA_NOVA = 'lfn',
  GANDA = 'lg',
  GANDA_UGANDA = 'lg_UG',
  LIMBURGISH = 'li',
  LIGURIAN = 'lij',
  LIVONIAN = 'liv',
  LAKOTA = 'lkt',
  LOMBARD = 'lmo',
  LINGALA = 'ln',
  LINGALA_CONGO___KINSHASA = 'ln_CD',
  LAO = 'lo',
  LAO_LAOS = 'lo_LA',
  MONGO = 'lol',
  LOZI = 'loz',
  NORTHERN_LURI = 'lrc',
  NORTHERN_LURI_IRAN = 'lrc_IR',
  LITHUANIAN = 'lt',
  LITHUANIAN_LITHUANIA = 'lt_LT',
  LITHUANIAN_POLAND = 'lt_PL',
  LATGALIAN = 'ltg',
  LUBA_KATANGA = 'lu',
  LUBA_KATANGA_CONGO___KINSHASA = 'lu_CD',
  LUBA_LULUA = 'lua',
  LUBA_LULUA_CONGO___KINSHASA = 'lua_CD',
  LUISENO = 'lui',
  LUNDA = 'lun',
  LUO = 'luo',
  LUO_KENYA = 'luo_KE',
  MIZO = 'lus',
  LUYIA = 'luy',
  LUYIA_KENYA = 'luy_KE',
  LATVIAN = 'lv',
  LATVIAN_LATVIA = 'lv_LV',
  LITERARY_CHINESE = 'lzh',
  LAZ_GEORGIAN = 'lzz#Geor',
  LAZ = 'lzz',
  MADURESE = 'mad',
  MADURESE_INDONESIA = 'mad_ID',
  MAFA = 'maf',
  MAGAHI = 'mag',
  MAGAHI_INDIA = 'mag_IN',
  MAITHILI = 'mai',
  MAITHILI_INDIA = 'mai_IN',
  MAITHILI_NEPAL = 'mai_NP',
  MAKASAR = 'mak',
  MAKASAR_INDONESIA = 'mak_ID',
  MANDINGO_GAMBIA = 'man_GM',
  MANDINGO_GUINEA_LATIN = 'man_GN#Latn',
  MANDINGO = 'man',
  MANDINGO_GAMBIA_N_KO = 'man_GM#Nkoo',
  MANDINGO_GUINEA = 'man_GN',
  MANDINGO_N_KO = 'man#Nkoo',
  MASAI = 'mas',
  MOKSHA = 'mdf',
  MOKSHA_RUSSIA = 'mdf_RU',
  MANDAR = 'mdr',
  MENDE = 'men',
  MENDE_SIERRA_LEONE = 'men_SL',
  MERU = 'mer',
  MERU_KENYA = 'mer_KE',
  MORISYEN = 'mfe',
  MORISYEN_MAURITIUS = 'mfe_MU',
  MALAGASY = 'mg',
  MALAGASY_MADAGASCAR = 'mg_MG',
  MAKHUWA_MEETTO = 'mgh',
  MAKHUWA_MEETTO_MOZAMBIQUE = 'mgh_MZ',
  METAʼ = 'mgo',
  MARSHALLESE = 'mh',
  MARSHALLESE_MARSHALL_ISLANDS = 'mh_MH',
  MAORI = 'mi',
  MAORI_NEW_ZEALAND = 'mi_NZ',
  MI_KMAQ = 'mic',
  MINANGKABAU = 'min',
  MINANGKABAU_INDONESIA = 'min_ID',
  MACEDONIAN = 'mk',
  MACEDONIAN_NORTH_MACEDONIA = 'mk_MK',
  MALAYALAM = 'ml',
  MALAYALAM_INDIA = 'ml_IN',
  MONGOLIAN = 'mn',
  MONGOLIAN_MONGOLIA = 'mn_MN',
  MONGOLIAN_CHINA = 'mn_CN',
  MANCHU = 'mnc',
  MANIPURI = 'mni',
  MANIPURI_INDIA = 'mni_IN',
  MANIPURI_INDIA_MEITEI_MAYEK = 'mni_IN#Mtei',
  MOHAWK = 'moh',
  MOSSI = 'mos',
  MOSSI_BURKINA_FASO = 'mos_BF',
  MARATHI = 'mr',
  MARATHI_INDIA = 'mr_IN',
  WESTERN_MARI = 'mrj',
  MALAY_BRUNEI_ARABIC = 'ms_BN#Arab',
  MALAY_MALAYSIA_ARABIC = 'ms_MY#Arab',
  MALAY_SINGAPORE_ARABIC = 'ms_SG#Arab',
  MALAY_COCOS_KEELING_ISLANDS = 'ms_CC',
  MALAY_INDONESIA = 'ms_ID',
  MALAY_ARABIC = 'ms#Arab',
  MALAY_BRUNEI = 'ms_BN',
  MALAY_MALAYSIA = 'ms_MY',
  MALAY_SINGAPORE = 'ms_SG',
  MALAY_COCOS_KEELING_ISLANDS_LATIN = 'ms_CC#Latn',
  MALAY_INDONESIA_LATIN = 'ms_ID#Latn',
  MALAY = 'ms',
  MALTESE = 'mt',
  MALTESE_MALTA = 'mt_MT',
  MUNDANG = 'mua',
  MUSCOGEE = 'mus',
  MIRANDESE = 'mwl',
  MARWARI = 'mwr',
  MARWARI_INDIA = 'mwr_IN',
  MENTAWAI = 'mwv',
  BURMESE = 'my',
  BURMESE_MYANMAR_BURMA = 'my_MM',
  ERZYA = 'myv',
  ERZYA_RUSSIA = 'myv_RU',
  MAZANDERANI = 'mzn',
  MAZANDERANI_IRAN = 'mzn_IR',
  NAURU = 'na',
  NAURU_NAURU = 'na_NR',
  MIN_NAN_CHINESE = 'nan',
  MIN_NAN_CHINESE_CHINA = 'nan_CN',
  NEAPOLITAN = 'nap',
  NAMA = 'naq',
  NORWEGIAN_BOKMÅL = 'nb',
  NORWEGIAN_BOKMÅL_NORWAY = 'nb_NO',
  NORWEGIAN_BOKMÅL_SVALBARD_AND_JAN_MAYEN = 'nb_SJ',
  NORTH_NDEBELE = 'nd',
  NORTH_NDEBELE_ZIMBABWE = 'nd_ZW',
  LOW_GERMAN = 'nds',
  LOW_GERMAN_GERMANY = 'nds_DE',
  LOW_SAXON = 'nds_NL',
  NEPALI = 'ne',
  NEPALI_NEPAL = 'ne_NP',
  NEPALI_INDIA = 'ne_IN',
  NEWARI = 'new',
  NDONGA = 'ng',
  NDONGA_NAMIBIA = 'ng_NA',
  NIAS = 'nia',
  NIUEAN = 'niu',
  NIUEAN_NIUE = 'niu_NU',
  AO_NAGA = 'njo',
  DUTCH = 'nl',
  DUTCH_ARUBA = 'nl_AW',
  FLEMISH = 'nl_BE',
  DUTCH_CARIBBEAN_NETHERLANDS = 'nl_BQ',
  DUTCH_CURAÇAO = 'nl_CW',
  DUTCH_NETHERLANDS = 'nl_NL',
  DUTCH_SURINAME = 'nl_SR',
  DUTCH_SINT_MAARTEN = 'nl_SX',
  DUTCH_GERMANY = 'nl_DE',
  KWASIO = 'nmg',
  NORWEGIAN_NYNORSK = 'nn',
  NORWEGIAN_NYNORSK_NORWAY = 'nn_NO',
  NGIEMBOON = 'nnh',
  NOGAI = 'nog',
  OLD_NORSE = 'non',
  NOVIAL = 'nov',
  N_KO = 'nqo',
  SOUTH_NDEBELE = 'nr',
  SOUTH_NDEBELE_SOUTH_AFRICA = 'nr_ZA',
  NORTHERN_SOTHO = 'nso',
  NORTHERN_SOTHO_SOUTH_AFRICA = 'nso_ZA',
  NUER = 'nus',
  NAVAJO = 'nv',
  NYANJA = 'ny',
  NYANJA_MALAWI = 'ny_MW',
  NYANJA_ZAMBIA = 'ny_ZM',
  NYAMWEZI = 'nym',
  NYAMWEZI_TANZANIA = 'nym_TZ',
  NYANKOLE = 'nyn',
  NYANKOLE_UGANDA = 'nyn_UG',
  NYORO = 'nyo',
  NZIMA = 'nzi',
  OCCITAN = 'oc',
  OCCITAN_FRANCE = 'oc_FR',
  OJIBWA = 'oj',
  OJIBWA_LATIN = 'oj#Latn',
  OROMO = 'om',
  OROMO_ETHIOPIA = 'om_ET',
  OROMO_ETHIOPIA_ETHIOPIC = 'om_ET#Ethi',
  ODIA = 'or',
  ODIA_INDIA = 'or_IN',
  OSSETIC = 'os',
  OSSETIC_GEORGIA = 'os_GE',
  OSAGE = 'osa',
  OSAGE_LATIN = 'osa#Latn',
  PUNJABI_INDIA_ARABIC = 'pa_IN#Arab',
  PUNJABI_ARABIC = 'pa#Arab',
  PUNJABI_PAKISTAN_GURMUKHI = 'pa_PK#Guru',
  PUNJABI = 'pa',
  PANGASINAN = 'pag',
  PANGASINAN_PHILIPPINES = 'pag_PH',
  PAHLAVI = 'pal',
  PAMPANGA = 'pam',
  PAMPANGA_PHILIPPINES = 'pam_PH',
  PAPIAMENTO = 'pap',
  PAPIAMENTO_ARUBA = 'pap_AW',
  PAPIAMENTO_CURAÇAO = 'pap_CW',
  PAPIAMENTO_CARIBBEAN_NETHERLANDS = 'pap_BQ',
  PALAUAN = 'pau',
  PALAUAN_PALAU = 'pau_PW',
  PICARD = 'pcd',
  NIGERIAN_PIDGIN = 'pcm',
  NIGERIAN_PIDGIN_NIGERIA = 'pcm_NG',
  PENNSYLVANIA_GERMAN = 'pdc',
  PLAUTDIETSCH = 'pdt',
  OLD_PERSIAN = 'peo',
  PALATINE_GERMAN = 'pfl',
  PHOENICIAN = 'phn',
  PALI = 'pi',
  PALI_SINHALA = 'pi#Sinh',
  PALI_THAI = 'pi#Thai',
  POLISH = 'pl',
  POLISH_POLAND = 'pl_PL',
  POLISH_UKRAINE = 'pl_UA',
  PIEDMONTESE = 'pms',
  PONTIC_CYRILLIC = 'pnt#Cyrl',
  PONTIC = 'pnt',
  PONTIC_LATIN = 'pnt#Latn',
  POHNPEIAN = 'pon',
  POHNPEIAN_MICRONESIA = 'pon_FM',
  PRUSSIAN = 'prg',
  OLD_PROVENÇAL = 'pro',
  PASHTO = 'ps',
  PASHTO_AFGHANISTAN = 'ps_AF',
  PASHTO_PAKISTAN = 'ps_PK',
  PORTUGUESE = 'pt',
  PORTUGUESE_ANGOLA = 'pt_AO',
  BRAZILIAN_PORTUGUESE = 'pt_BR',
  PORTUGUESE_CAPE_VERDE = 'pt_CV',
  PORTUGUESE_EQUATORIAL_GUINEA = 'pt_GQ',
  PORTUGUESE_GUINEA_BISSAU = 'pt_GW',
  PORTUGUESE_MACAO_SAR_CHINA = 'pt_MO',
  PORTUGUESE_MOZAMBIQUE = 'pt_MZ',
  EUROPEAN_PORTUGUESE = 'pt_PT',
  PORTUGUESE_SÃO_TOMÉ_AND_PRÍNCIPE = 'pt_ST',
  PORTUGUESE_TIMOR_LESTE = 'pt_TL',
  QUECHUA = 'qu',
  QUECHUA_BOLIVIA = 'qu_BO',
  QUECHUA_ECUADOR = 'qu_EC',
  QUECHUA_PERU = 'qu_PE',
  KʼICHEʼ = 'quc',
  KʼICHEʼ_GUATEMALA = 'quc_GT',
  CHIMBORAZO_HIGHLAND_QUICHUA = 'qug',
  RAJASTHANI = 'raj',
  RAJASTHANI_INDIA = 'raj_IN',
  RAPANUI = 'rap',
  RAROTONGAN = 'rar',
  ROMAGNOL = 'rgn',
  RIFFIAN_MOROCCO_LATIN = 'rif_MA#Latn',
  RIFFIAN_LATIN = 'rif#Latn',
  RIFFIAN_MOROCCO = 'rif_MA',
  RIFFIAN = 'rif',
  ROMANSH = 'rm',
  ROMANSH_SWITZERLAND = 'rm_CH',
  RUNDI = 'rn',
  RUNDI_BURUNDI = 'rn_BI',
  ROMANIAN = 'ro',
  MOLDAVIAN = 'ro_MD',
  ROMANIAN_ROMANIA = 'ro_RO',
  ROMANIAN_SERBIA = 'ro_RS',
  ROMANIAN_MOLDOVA_CYRILLIC = 'ro_MD#Cyrl',
  ROMANIAN_ROMANIA_CYRILLIC = 'ro_RO#Cyrl',
  ROMANIAN_SERBIA_CYRILLIC = 'ro_RS#Cyrl',
  ROMBO = 'rof',
  ROMANY = 'rom',
  ROMANY_CYRILLIC = 'rom#Cyrl',
  ROTUMAN = 'rtm',
  RUSSIAN = 'ru',
  RUSSIAN_BELARUS = 'ru_BY',
  RUSSIAN_KYRGYZSTAN = 'ru_KG',
  RUSSIAN_KAZAKHSTAN = 'ru_KZ',
  RUSSIAN_RUSSIA = 'ru_RU',
  RUSSIAN_UKRAINE = 'ru_UA',
  RUSSIAN_BULGARIA = 'ru_BG',
  RUSSIAN_GERMANY = 'ru_DE',
  RUSSIAN_ESTONIA = 'ru_EE',
  RUSSIAN_LITHUANIA = 'ru_LT',
  RUSSIAN_LATVIA = 'ru_LV',
  RUSSIAN_POLAND = 'ru_PL',
  RUSSIAN_SVALBARD_AND_JAN_MAYEN = 'ru_SJ',
  RUSSIAN_TAJIKISTAN = 'ru_TJ',
  RUSSIAN_UZBEKISTAN = 'ru_UZ',
  RUSYN = 'rue',
  ROVIANA = 'rug',
  AROMANIAN = 'rup',
  KINYARWANDA = 'rw',
  KINYARWANDA_RWANDA = 'rw_RW',
  RWA = 'rwk',
  SANSKRIT_INDIA = 'sa_IN',
  SANSKRIT = 'sa',
  SANSKRIT_INDIA_SINHALA = 'sa_IN#Sinh',
  SANSKRIT_SINHALA = 'sa#Sinh',
  SANDAWE = 'sad',
  SAKHA = 'sah',
  SAKHA_RUSSIA = 'sah_RU',
  SAMARITAN_ARAMAIC = 'sam',
  SAMBURU = 'saq',
  SASAK = 'sas',
  SASAK_INDONESIA = 'sas_ID',
  SANTALI = 'sat',
  SANTALI_INDIA = 'sat_IN',
  SANTALI_INDIA_BANGLA = 'sat_IN#Beng',
  SANTALI_INDIA_DEVANAGARI = 'sat_IN#Deva',
  SANTALI_INDIA_OL_CHIKI = 'sat_IN#Olck',
  SANTALI_INDIA_ODIA = 'sat_IN#Orya',
  SAURASHTRA = 'saz',
  SANGU = 'sbp',
  SARDINIAN = 'sc',
  SARDINIAN_ITALY = 'sc_IT',
  SICILIAN = 'scn',
  SCOTS = 'sco',
  SCOTS_UNITED_KINGDOM = 'sco_GB',
  SINDHI_INDIA_ARABIC = 'sd_IN#Arab',
  SINDHI_PAKISTAN = 'sd_PK',
  SINDHI = 'sd',
  SINDHI_INDIA = 'sd_IN',
  SINDHI_PAKISTAN_DEVANAGARI = 'sd_PK#Deva',
  SINDHI_DEVANAGARI = 'sd#Deva',
  SINDHI_INDIA_KHUDAWADI = 'sd_IN#Sind',
  SINDHI_PAKISTAN_KHUDAWADI = 'sd_PK#Sind',
  SINDHI_KHUDAWADI = 'sd#Sind',
  SASSARESE_SARDINIAN = 'sdc',
  SOUTHERN_KURDISH = 'sdh',
  SOUTHERN_KURDISH_IRAN = 'sdh_IR',
  NORTHERN_SAMI = 'se',
  NORTHERN_SAMI_NORWAY = 'se_NO',
  NORTHERN_SAMI_NORWAY_CYRILLIC = 'se_NO#Cyrl',
  SENECA = 'see',
  SENA = 'seh',
  SENA_MOZAMBIQUE = 'seh_MZ',
  SERI = 'sei',
  SELKUP = 'sel',
  KOYRABORO_SENNI = 'ses',
  SANGO = 'sg',
  SANGO_CENTRAL_AFRICAN_REPUBLIC = 'sg_CF',
  OLD_IRISH = 'sga',
  SAMOGITIAN = 'sgs',
  TACHELHIT_MOROCCO_ARABIC = 'shi_MA#Arab',
  TACHELHIT_ARABIC = 'shi#Arab',
  TACHELHIT_MOROCCO_LATIN = 'shi_MA#Latn',
  TACHELHIT_LATIN = 'shi#Latn',
  TACHELHIT = 'shi',
  SHAN = 'shn',
  SHAN_MYANMAR_BURMA = 'shn_MM',
  SINHALA = 'si',
  SINHALA_SRI_LANKA = 'si_LK',
  SIDAMO = 'sid',
  SIDAMO_ETHIOPIA = 'sid_ET',
  SLOVAK = 'sk',
  SLOVAK_SLOVAKIA = 'sk_SK',
  SLOVAK_CZECHIA = 'sk_CZ',
  SLOVAK_SERBIA = 'sk_RS',
  SLOVENIAN = 'sl',
  SLOVENIAN_SLOVENIA = 'sl_SI',
  SLOVENIAN_AUSTRIA = 'sl_AT',
  LOWER_SILESIAN = 'sli',
  SELAYAR = 'sly',
  SAMOAN = 'sm',
  SAMOAN_AMERICAN_SAMOA = 'sm_AS',
  SAMOAN_SAMOA = 'sm_WS',
  SOUTHERN_SAMI = 'sma',
  LULE_SAMI = 'smj',
  INARI_SAMI = 'smn',
  SKOLT_SAMI = 'sms',
  SHONA = 'sn',
  SHONA_ZIMBABWE = 'sn_ZW',
  SONINKE = 'snk',
  SONINKE_MALI = 'snk_ML',
  SOMALI = 'so',
  SOMALI_SOMALIA = 'so_SO',
  SOMALI_DJIBOUTI = 'so_DJ',
  SOMALI_ETHIOPIA = 'so_ET',
  SOMALI_SOMALIA_ARABIC = 'so_SO#Arab',
  SOMALI_DJIBOUTI_ARABIC = 'so_DJ#Arab',
  SOMALI_ETHIOPIA_ARABIC = 'so_ET#Arab',
  ALBANIAN = 'sq',
  ALBANIAN_ALBANIA = 'sq_AL',
  ALBANIAN_KOSOVO = 'sq_XK',
  ALBANIAN_NORTH_MACEDONIA = 'sq_MK',
  ALBANIAN_SERBIA = 'sq_RS',
  SERBIAN_MONTENEGRO_CYRILLIC = 'sr_ME#Cyrl',
  SERBIAN = 'sr',
  SERBIAN_BOSNIA_AND_HERZEGOVINA_LATIN = 'sr_BA#Latn',
  SERBIAN_SERBIA_LATIN = 'sr_RS#Latn',
  SERBIAN_KOSOVO_LATIN = 'sr_XK#Latn',
  SERBIAN_LATIN = 'sr#Latn',
  SRANAN_TONGO = 'srn',
  SRANAN_TONGO_SURINAME = 'srn_SR',
  SERER = 'srr',
  SERER_SENEGAL = 'srr_SN',
  SWATI = 'ss',
  SWATI_ESWATINI = 'ss_SZ',
  SWATI_SOUTH_AFRICA = 'ss_ZA',
  SAHO = 'ssy',
  SOUTHERN_SOTHO = 'st',
  SOUTHERN_SOTHO_LESOTHO = 'st_LS',
  SOUTHERN_SOTHO_SOUTH_AFRICA = 'st_ZA',
  SATERLAND_FRISIAN = 'stq',
  SUNDANESE = 'su',
  SUNDANESE_INDONESIA = 'su_ID',
  SUNDANESE_INDONESIA_SUNDANESE = 'su_ID#Sund',
  SUKUMA = 'suk',
  SUKUMA_TANZANIA = 'suk_TZ',
  SUSU = 'sus',
  SUSU_GUINEA = 'sus_GN',
  SUSU_GUINEA_ARABIC = 'sus_GN#Arab',
  SWEDISH = 'sv',
  SWEDISH_ÅLAND_ISLANDS = 'sv_AX',
  SWEDISH_FINLAND = 'sv_FI',
  SWEDISH_SWEDEN = 'sv_SE',
  SWAHILI = 'sw',
  SWAHILI_KENYA = 'sw_KE',
  SWAHILI_TANZANIA = 'sw_TZ',
  SWAHILI_UGANDA = 'sw_UG',
  CONGO_SWAHILI = 'sw_CD',
  COMORIAN = 'swb',
  COMORIAN_MAYOTTE = 'swb_YT',
  COMORIAN_MAYOTTE_LATIN = 'swb_YT#Latn',
  SYRIAC = 'syr',
  SILESIAN = 'szl',
  TAMIL = 'ta',
  TAMIL_SRI_LANKA = 'ta_LK',
  TAMIL_SINGAPORE = 'ta_SG',
  TAMIL_INDIA = 'ta_IN',
  TAMIL_MALAYSIA = 'ta_MY',
  TULU = 'tcy',
  TULU_INDIA = 'tcy_IN',
  TELUGU = 'te',
  TELUGU_INDIA = 'te_IN',
  TIMNE = 'tem',
  TIMNE_SIERRA_LEONE = 'tem_SL',
  TESO = 'teo',
  TESO_UGANDA = 'teo_UG',
  TERENO = 'ter',
  TETUM = 'tet',
  TETUM_TIMOR_LESTE = 'tet_TL',
  TAJIK_TAJIKISTAN_ARABIC = 'tg_TJ#Arab',
  TAJIK_ARABIC = 'tg#Arab',
  TAJIK_TAJIKISTAN = 'tg_TJ',
  TAJIK = 'tg',
  TAJIK_TAJIKISTAN_LATIN = 'tg_TJ#Latn',
  TAJIK_LATIN = 'tg#Latn',
  THAI = 'th',
  THAI_THAILAND = 'th_TH',
  TIGRINYA = 'ti',
  TIGRINYA_ERITREA = 'ti_ER',
  TIGRINYA_ETHIOPIA = 'ti_ET',
  TIGRE = 'tig',
  TIGRE_ERITREA = 'tig_ER',
  TIV = 'tiv',
  TIV_NIGERIA = 'tiv_NG',
  TURKMEN_TURKMENISTAN_ARABIC = 'tk_TM#Arab',
  TURKMEN_AFGHANISTAN_ARABIC = 'tk_AF#Arab',
  TURKMEN_IRAN_ARABIC = 'tk_IR#Arab',
  TURKMEN_ARABIC = 'tk#Arab',
  TURKMEN_TURKMENISTAN_CYRILLIC = 'tk_TM#Cyrl',
  TURKMEN_AFGHANISTAN_CYRILLIC = 'tk_AF#Cyrl',
  TURKMEN_IRAN_CYRILLIC = 'tk_IR#Cyrl',
  TURKMEN_CYRILLIC = 'tk#Cyrl',
  TURKMEN_TURKMENISTAN = 'tk_TM',
  TURKMEN_AFGHANISTAN = 'tk_AF',
  TURKMEN_IRAN = 'tk_IR',
  TURKMEN = 'tk',
  TOKELAU = 'tkl',
  TOKELAU_TOKELAU = 'tkl_TK',
  TSAKHUR_CYRILLIC = 'tkr#Cyrl',
  TSAKHUR = 'tkr',
  TLINGIT = 'tli',
  TALYSH_ARABIC = 'tly#Arab',
  TALYSH_CYRILLIC = 'tly#Cyrl',
  TALYSH = 'tly',
  TAMASHEK = 'tmh',
  TAMASHEK_NIGER = 'tmh_NE',
  TSWANA = 'tn',
  TSWANA_BOTSWANA = 'tn_BW',
  TSWANA_SOUTH_AFRICA = 'tn_ZA',
  TONGAN = 'to',
  TONGAN_TONGA = 'to_TO',
  NYASA_TONGA = 'tog',
  TOK_PISIN = 'tpi',
  TOK_PISIN_PAPUA_NEW_GUINEA = 'tpi_PG',
  TURKISH = 'tr',
  TURKISH_CYPRUS = 'tr_CY',
  TURKISH_TURKEY = 'tr_TR',
  TURKISH_GERMANY = 'tr_DE',
  TURKISH_CYPRUS_ARABIC = 'tr_CY#Arab',
  TURKISH_TURKEY_ARABIC = 'tr_TR#Arab',
  TURKISH_GERMANY_ARABIC = 'tr_DE#Arab',
  TUROYO = 'tru',
  TUROYO_SYRIAC = 'tru#Syrc',
  TAROKO = 'trv',
  TSONGA = 'ts',
  TSONGA_MOZAMBIQUE = 'ts_MZ',
  TSONGA_SOUTH_AFRICA = 'ts_ZA',
  TSAKONIAN = 'tsd',
  TSIMSHIAN = 'tsi',
  TATAR = 'tt',
  TATAR_RUSSIA = 'tt_RU',
  MUSLIM_TAT_CYRILLIC = 'ttt#Cyrl',
  MUSLIM_TAT = 'ttt',
  MUSLIM_TAT_ARABIC = 'ttt#Arab',
  TUMBUKA = 'tum',
  TUMBUKA_MALAWI = 'tum_MW',
  TUVALU = 'tvl',
  TUVALU_TUVALU = 'tvl_TV',
  TASAWAQ = 'twq',
  TAHITIAN = 'ty',
  TAHITIAN_FRENCH_POLYNESIA = 'ty_PF',
  TUVINIAN = 'tyv',
  TUVINIAN_RUSSIA = 'tyv_RU',
  CENTRAL_ATLAS_TAMAZIGHT_MOROCCO = 'tzm_MA',
  CENTRAL_ATLAS_TAMAZIGHT = 'tzm',
  CENTRAL_ATLAS_TAMAZIGHT_MOROCCO_TIFINAGH = 'tzm_MA#Tfng',
  CENTRAL_ATLAS_TAMAZIGHT_TIFINAGH = 'tzm#Tfng',
  UDMURT = 'udm',
  UDMURT_RUSSIA = 'udm_RU',
  UDMURT_RUSSIA_LATIN = 'udm_RU#Latn',
  UYGHUR_CHINA = 'ug_CN',
  UYGHUR = 'ug',
  UYGHUR_CHINA_CYRILLIC = 'ug_CN#Cyrl',
  UYGHUR_CYRILLIC = 'ug#Cyrl',
  UYGHUR_CHINA_LATIN = 'ug_CN#Latn',
  UYGHUR_LATIN = 'ug#Latn',
  UGARITIC = 'uga',
  UKRAINIAN = 'uk',
  UKRAINIAN_UKRAINE = 'uk_UA',
  UKRAINIAN_SERBIA = 'uk_RS',
  UMBUNDU = 'umb',
  UMBUNDU_ANGOLA = 'umb_AO',
  URDU = 'ur',
  URDU_PAKISTAN = 'ur_PK',
  URDU_INDIA = 'ur_IN',
  UZBEK_UZBEKISTAN_ARABIC = 'uz_UZ#Arab',
  UZBEK_ARABIC = 'uz#Arab',
  UZBEK_UZBEKISTAN_CYRILLIC = 'uz_UZ#Cyrl',
  UZBEK_AFGHANISTAN_CYRILLIC = 'uz_AF#Cyrl',
  UZBEK_CYRILLIC = 'uz#Cyrl',
  UZBEK_AFGHANISTAN_LATIN = 'uz_AF#Latn',
  UZBEK = 'uz',
  VAI_LATIN = 'vai#Latn',
  VAI = 'vai',
  VENDA = 've',
  VENDA_SOUTH_AFRICA = 've_ZA',
  VENETIAN = 'vec',
  VEPS = 'vep',
  VIETNAMESE = 'vi',
  VIETNAMESE_VIETNAM = 'vi_VN',
  VIETNAMESE_UNITED_STATES = 'vi_US',
  WEST_FLEMISH = 'vls',
  WEST_FLEMISH_BELGIUM = 'vls_BE',
  MAIN_FRANCONIAN = 'vmf',
  MAIN_FRANCONIAN_GERMANY = 'vmf_DE',
  VOLAPÜK = 'vo',
  VOTIC = 'vot',
  VÕRO = 'vro',
  VUNJO = 'vun',
  WALLOON = 'wa',
  WALSER = 'wae',
  WOLAYTTA = 'wal',
  WOLAYTTA_ETHIOPIA = 'wal_ET',
  WARAY = 'war',
  WARAY_PHILIPPINES = 'war_PH',
  WASHO = 'was',
  WARLPIRI = 'wbp',
  WOLOF = 'wo',
  WOLOF_SENEGAL = 'wo_SN',
  WOLOF_SENEGAL_ARABIC = 'wo_SN#Arab',
  WU_CHINESE = 'wuu',
  WU_CHINESE_CHINA = 'wuu_CN',
  KALMYK = 'xal',
  XHOSA = 'xh',
  XHOSA_SOUTH_AFRICA = 'xh_ZA',
  MINGRELIAN = 'xmf',
  SOGA = 'xog',
  SOGA_UGANDA = 'xog_UG',
  YAO = 'yao',
  YAPESE = 'yap',
  YANGBEN = 'yav',
  YEMBA = 'ybb',
  YIDDISH = 'yi',
  YORUBA = 'yo',
  YORUBA_NIGERIA = 'yo_NG',
  NHEENGATU = 'yrl',
  CANTONESE_HONG_KONG_SAR_CHINA_SIMPLIFIED = 'yue_HK#Hans',
  CANTONESE_SIMPLIFIED = 'yue#Hans',
  CANTONESE_CHINA_TRADITIONAL = 'yue_CN#Hant',
  CANTONESE = 'yue',
  ZHUANG = 'za',
  ZHUANG_CHINA = 'za_CN',
  ZHUANG_CHINA_SIMPLIFIED = 'za_CN#Hans',
  ZAPOTEC = 'zap',
  ZEELANDIC = 'zea',
  ZENAGA = 'zen',
  STANDARD_MOROCCAN_TAMAZIGHT = 'zgh',
  STANDARD_MOROCCAN_TAMAZIGHT_MOROCCO = 'zgh_MA',
  CHINESE_HONG_KONG_SAR_CHINA_SIMPLIFIED = 'zh_HK#Hans',
  CHINESE_MACAO_SAR_CHINA_SIMPLIFIED = 'zh_MO#Hans',
  CHINESE_TAIWAN_SIMPLIFIED = 'zh_TW#Hans',
  CHINESE_INDONESIA_SIMPLIFIED = 'zh_ID#Hans',
  CHINESE_MALAYSIA_SIMPLIFIED = 'zh_MY#Hans',
  CHINESE_THAILAND_SIMPLIFIED = 'zh_TH#Hans',
  CHINESE_UNITED_STATES_SIMPLIFIED = 'zh_US#Hans',
  CHINESE_VIETNAM_SIMPLIFIED = 'zh_VN#Hans',
  CHINESE_CHINA_TRADITIONAL = 'zh_CN#Hant',
  CHINESE_SINGAPORE_TRADITIONAL = 'zh_SG#Hant',
  CHINESE_INDONESIA = 'zh_ID',
  CHINESE_MALAYSIA = 'zh_MY',
  CHINESE_THAILAND = 'zh_TH',
  CHINESE_UNITED_STATES = 'zh_US',
  CHINESE_VIETNAM = 'zh_VN',
  ZULU = 'zu',
  ZULU_SOUTH_AFRICA = 'zu_ZA',
  ZUNI = 'zun',
  ZAZA = 'zza',
  ZAZA_TURKEY = 'zza_TR',
  AZERBAIJANI_AZERBAIJAN_LATIN = 'az_AZ#Latn',
  BOSNIAN_BOSNIA_AND_HERZEGOVINA_LATIN = 'bs_BA#Latn',
  PUNJABI_INDIA_GURMUKHI = 'pa_IN#Guru',
  PUNJABI_PAKISTAN_ARABIC = 'pa_PK#Arab',
  TACHELHIT_MOROCCO_TIFINAGH = 'shi_MA#Tfng',
  SERBIAN_BOSNIA_AND_HERZEGOVINA_CYRILLIC = 'sr_BA#Cyrl',
  SERBIAN_MONTENEGRO_LATIN = 'sr_ME#Latn',
  SERBIAN_SERBIA_CYRILLIC = 'sr_RS#Cyrl',
  SERBIAN_KOSOVO_CYRILLIC = 'sr_XK#Cyrl',
  UZBEK_AFGHANISTAN_ARABIC = 'uz_AF#Arab',
  UZBEK_UZBEKISTAN_LATIN = 'uz_UZ#Latn',
  CANTONESE_CHINA_SIMPLIFIED = 'yue_CN#Hans',
  CANTONESE_HONG_KONG_SAR_CHINA_TRADITIONAL = 'yue_HK#Hant',
  CHINESE_CHINA_SIMPLIFIED = 'zh_CN#Hans',
  CHINESE_HONG_KONG_SAR_CHINA_TRADITIONAL = 'zh_HK#Hant',
  CHINESE_MACAO_SAR_CHINA_TRADITIONAL = 'zh_MO#Hant',
  CHINESE_SINGAPORE_SIMPLIFIED = 'zh_SG#Hans',
  CHINESE_TAIWAN_TRADITIONAL = 'zh_TW#Hant',
  TRADITIONAL_CHINESE = 'zh#Hant',
  MODERN_STANDARD_ARABIC = 'ar_001',
  ENGLISH_WORLD = 'en_001',
  YIDDISH_WORLD = 'yi_001',
  ENGLISH_EUROPE = 'en_150',
  NORTHERN_SAMI_SWEDEN = 'se_SE',
  ENGLISH_ANDORRA = 'en_AD',
  ENGLISH_MYANMAR_BURMA = 'en_MM',
  ALGONQUIN = 'alq',
  LADIN = 'lld',
  OJIBWA_1481 = 'oji',
  DEVELOPER_ENGLISH = 'xxa',
  CUSTOM_SOURCE = 'xxb',
  CUSTOM_LOCALE_1 = 'xxc',
  CUSTOM_LOCALE_2 = 'xxd',
  CUSTOM_LOCALE_3 = 'xxe',
  CUSTOM_LOCALE_4 = 'xxf',
  CUSTOM_LOCALE_5 = 'xxg',
}
